<template>

  <main class="pricing-page" role="main">
    <h1>Pricing Page</h1>
  </main>

</template>

<script>

export default {
  name: 'pricing',
  components: {
    
  }
}
</script>